import { Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { SampleComponent } from '../pbi/sample/sample.component';
import { RoleService } from '../roles/role.service';
import { StructuredMenu } from '../sidebar/sidebar-item/menu-types';

@Injectable({
  providedIn: 'root'
})
export class RouteService {

  constructor(private roleService: RoleService) { }

  public async getPbiRoutes(): Promise<Route[]> {
    let routes: Route[];
    await this.roleService.getPbiMenus()
      .forEach(response => {

        const listedMenus: Record<string, StructuredMenu> = {};
        const structuredMenus: Array<StructuredMenu> = [];
        response.result.forEach(item => {
          listedMenus[item.menu_id] = item;
          if (!item.menu_id.includes(".")) structuredMenus.push(item);
          else {
            let parentMenuId = item.menu_id.substring(0, item.menu_id.lastIndexOf('.'));
            let parentMenu = listedMenus[parentMenuId];
            while (!parentMenu && !(parentMenuId == '')) {
              parentMenuId = parentMenuId.substring(0, parentMenuId.lastIndexOf('.'));
              parentMenu = listedMenus[parentMenuId];
            }
            if (parentMenu.children) parentMenu.children.push(item);
            else parentMenu.children = [item];
          }
        });

        routes = structuredMenus.map(menu => this.buildMenuItems(menu)) as Route[];
      });

    return (routes || []).filter(Boolean) as Route[];
  }

  private buildMenuItems = (menu?: StructuredMenu | StructuredMenu[]): void | Route | Route[] => {
    if (!menu) return;

    // Lista
    if (Array.isArray(menu)) {
      return (menu.map(item => this.buildMenuItems(item)) as Array<Route | void>)
        .filter(Boolean) as Route[];
    }

    // Nó único
    const builtChildren = (this.buildMenuItems(menu.children) as Route[] | void) || [];
    const children = Array.isArray(builtChildren)
      ? (builtChildren.filter(Boolean) as Route[])
      : [];

    const hasChildren = children.length > 0;
    const hasReport = !!menu.reportid;

    // Normaliza path (evita path vazio que quebra o router)
    const rawUrl = (menu.url || '').toString().trim();
    const normalizedUrl = rawUrl.replace(/^\//, ''); // remove leading '/'
    const path = normalizedUrl || (menu.menu_id ? String(menu.menu_id).replace(/\./g, '-') : '');

    // Se não tem componente nem filhos, não gera rota (evita "Invalid configuration of route")
    if (!hasReport && !hasChildren) return;

    const route: Route = {
      path,
      data: {
        id: menu.menu_id,
        title: menu.menu_title,
        icon: menu.icon,
        collapse: menu.collapse,
        reportId: menu.reportid,
        groupId: menu.groupid,
        datasetId: menu.datasetid,
        pageName: menu.pagename,
        parent: menu.parent
      },
    };

    if (hasReport) route.component = SampleComponent;
    if (hasChildren) route.children = children;

    return route;
  }
}
